import React, { Component } from "react";
import MenuItem from "./MenuItem/MenuItem";
import Hoc from '../../Hoc/Hoc'


class Menu extends Component {

    render() {
        return (
            <Hoc>
                <MenuItem ShowLoginBox={this.show}/>
            </Hoc>
        )
    }
}

export default Menu